module.exports = __webpack_public_path__ + "assets/img/kv-a95c8148.jpg";